import React, { StrictMode } from 'react';

import { ContextProvider } from 'components/Users/Context';

import Main from './Main';

export default function Index() {
  return (
    <StrictMode><ContextProvider><Main /></ContextProvider></StrictMode>
  );
}
